/**
 * Trending Products
 * - Tab functionality
 *
 * @author Matt <matt@joipolloi.com>
 * @package Minifigs 2.0
 */

const trendingProducts = () => {
    const trendingProducts = document.getElementById('trendingProducts');
    const trendingProductFilters = document.getElementById('trendingProductFilters');
    const trendingProductItemContainer = document.getElementById('trendingProductItems');
    if (!trendingProducts || !trendingProductFilters || !trendingProductItemContainer) return;

    const trendingProductItems = Array.from(trendingProductItemContainer.querySelectorAll('.trendingProductItem'));
    const filterButtons = Array.from(trendingProductFilters.querySelectorAll('.filter'));

    filterButtons.forEach(filterButton => {
        filterButton.addEventListener('click', e => {
            filterButtons.forEach(button => {
                if (e.target === button) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }
            });

            trendingProductItems.forEach(item => {
                if (item.dataset.filter === filterButton.dataset.filter) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active')
                }
            });
        });
    });
};

export default trendingProducts;
